/* ElectroDentist joined reading room. Uses only allowlisted editorial keys.
   Query values never become HTML. No customer identifiers or remote APIs. */
(function () {
  'use strict';
  var root = document.getElementById('ed-magazine-reader');
  if (!root) return;
  var editions = window.ED_MAGAZINE_EDITIONS || {};
  var params = new URLSearchParams(location.search);
  var profile = params.get('edition') || '';
  var issue = params.get('part') || params.get('issue') || '';
  var selected = Object.prototype.hasOwnProperty.call(editions, profile + ':' + issue) ? editions[profile + ':' + issue] : null;
  var fallback = document.getElementById('ed-reader-fallback');
  if (!selected) { if (fallback) fallback.hidden = false; return; }
  var content = document.getElementById('ed-reader-content');
  function element(tag, text, className) {
    var el = document.createElement(tag); if (text) el.textContent = text;
    if (className) el.className = className; return el;
  }
  var hero = element('header', '', 'ed-reader-hero');
  hero.appendChild(element('p', selected.kind === 'caregiver' ? 'ELECTRODENTIST / KIDS WORLD' : 'ELECTRODENTIST / YOUR MAGAZINE', 'ed-reader-eyebrow'));
  hero.appendChild(element('h1', selected.title));
  hero.appendChild(element('p', selected.standfirst, 'ed-reader-standfirst'));
  var art = window.ED_READER_ART || {};
  var artItem = art['t' + String(selected.cover_topic).padStart(2, '0')];
  if (artItem && /^https:\/\/cdn\.shopify\.com\//.test(artItem.url)) {
    var figure = element('figure', '', 'ed-reader-art');
    var img = element('img'); img.src = artItem.url; img.alt = artItem.alt || 'An everyday oral-care routine in a calm, naturally lit space.';
    img.width = 1536; img.height = 1024; img.decoding = 'async'; figure.appendChild(img); hero.appendChild(figure);
  }
  content.appendChild(hero);
  var story = element('div', '', 'ed-reader-story');
  selected.sections.forEach(function (part) {
    var section = element('section'); section.appendChild(element('h2', part.heading));
    part.paragraphs.forEach(function (p) { section.appendChild(element('p', p)); });
    story.appendChild(section);
  });
  var details = element('section', '', 'ed-reader-details');
  details.appendChild(element('h2', 'Explore the detail that fits'));
  details.appendChild(element('p', 'Each article below adds depth to the joined plan. Start with the part you want to understand more clearly.'));
  var list = element('ul');
  selected.links.forEach(function (link) {
    // The build produces only this first-party allowlist; reject malformed payloads.
    if (!/^https:\/\/electrodentist\.com\/pages\/ed-/.test(link.url)) return;
    var li = element('li'); var a = element('a', link.title); a.href = link.url;
    a.setAttribute('data-ed-related', '1'); li.appendChild(a); list.appendChild(li);
  });
  details.appendChild(list); story.appendChild(details);
  story.appendChild(element('p', selected.scope, 'ed-reader-scope'));
  content.appendChild(story);
  var controls = element('div', '', 'ed-reader-controls');
  var copyButton = element('button', 'Copy this edition'); copyButton.type = 'button';
  var printButton = element('button', 'Print or save as PDF'); printButton.type = 'button';
  var message = element('p', '', 'ed-reader-message'); message.setAttribute('role','status');
  copyButton.addEventListener('click', function () {
    var text = selected.title + '\n\n' + selected.standfirst + '\n\n';
    selected.sections.forEach(function (s) { text += s.heading + '\n' + s.paragraphs.join('\n\n') + '\n\n'; });
    text += 'Further reading\n' + selected.links.map(function (l) { return l.title + '\n' + l.url; }).join('\n\n');
    text += '\n\nReturn to this edition:\n' + location.origin + location.pathname + '?edition=' + encodeURIComponent(selected.profile) + '&part=' + encodeURIComponent(selected.issue);
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(function () {message.textContent='Copied. Paste it into your notes to keep the reading links.';}).catch(function () {message.textContent='Copy is unavailable in this browser. Use Print or save as PDF instead.';});
    else message.textContent='Copy is unavailable in this browser. Use Print or save as PDF instead.';
  });
  printButton.addEventListener('click', function () { window.print(); });
  controls.appendChild(copyButton); controls.appendChild(printButton); controls.appendChild(message); content.appendChild(controls);
  content.hidden = false; if (fallback) fallback.hidden = true;
  document.title = selected.title + ' | ElectroDentist Magazine';
  // No diagnosis or preference is sent to analytics by this renderer.

  var review = params.get('view') === 'ed-review-reader';
  if (review) root.querySelectorAll('a[href]').forEach(function(a){
    var u=new URL(a.href), match=u.pathname.match(/^\/pages\/(ed-(?:mag-|amplifier-).+)$/);
    if(match){u.pathname='/pages/contact';u.searchParams.set('view','ed-review-'+match[1].slice(3));u.searchParams.set('preview_theme_id','206178451801');a.href=u.href;}
  });
  root.setAttribute('data-ed-content','ED-READER-'+selected.profile+'-'+selected.issue);
  root.setAttribute('data-ed-kind',selected.kind);
  root.setAttribute('data-ed-edition-loaded','true');
})();
